 import api from "../../api.js";

export async function fetchMedicalHistory(patientId, type, branchcode) {
  const res = await api.get(`/api/medical-history/patient/${encodeURIComponent(patientId)}`, {
    params: {
      ...(type ? { type } : {}),
      ...(branchcode ? { branchcode } : {}),
    },
  });
  return res.data?.data || [];
}

export async function fetchPrescriptionPayment(prescriptionId) {
  const res = await api.get(`/api/medical-history/prescription/${encodeURIComponent(prescriptionId)}/payment`);
  return res.data?.data || null;
}
